import * as React from "react";
import { Text, View } from "react-native";
import { NavigationContainer } from "@react-navigation/native";
import { createBottomTabNavigator } from "@react-navigation/bottom-tabs";
import Ionicons from "@expo/vector-icons/Ionicons";
import SettingsScreen from "../Settings/Settings";
import HomeScreen from "../Home/Home";
import { Header } from "react-native-elements";
import { createStackNavigator } from "@react-navigation/stack";
import NewPage from "../Home/NewPage";
import Swiper from "../Home/Swiper";
import { SafeAreaProvider } from "react-native-safe-area-context";
import Profile from "../Profile/Profile";
import Walkthrough from "../Walkthrough/TestPage";
import LeaderBoard from "../Leaderboard/LeaderBoard";
import FullImage from "../Profile/FullImage";
import PicksView from "../Profile/PicksView";

import TermsAndConditions from "../Settings/TermsConditions";

const Tab = createBottomTabNavigator();

function HomeTabs() {
  return (
    <Tab.Navigator
      screenOptions={({ route }) => ({
        tabBarIcon: ({ focused, color, size }) => {
          let iconName;

          if (route.name === "Home") {
            iconName = focused ? "ios-home" : "ios-home";
          } else if (route.name === "Profile") {
            iconName = focused ? "md-person" : "md-person";
          } else if (route.name === "Leaderboard") {
            iconName = focused ? "ios-podium" : "ios-podium";
          } else if (route.name === "Walkthrough") {
            iconName = focused ? "ios-podium" : "ios-podium";
          } // You can return any component that you like here!
          return <Ionicons name={iconName} size={size} color={color} />;
        },
      })}
      tabBarOptions={{
        activeTintColor: "tomato",
        inactiveTintColor: "gray",
      }}
      initialRouteName="Home"
    >
      <Tab.Screen name="Profile" component={Profile} style={{
      marginLeft:"200"
    }}/>
      <Tab.Screen name="Home" component={HomeScreen} />
      <Tab.Screen name="Leaderboard" component={LeaderBoard} />
      {/* <Tab.Screen name="Walkthrough" component={Walkthrough} /> */}
    </Tab.Navigator>
  );
}
const RootStack = createStackNavigator();

export default function App() {
  return (

    <SafeAreaProvider>


    <RootStack.Navigator >
      <RootStack.Screen
        name="Home"
        component={HomeTabs}
        options={{ headerShown: false }}
      />

      <RootStack.Screen name="Settings" component={SettingsScreen} />

      <RootStack.Screen
      style={{
        width:200
      }}
        name="Swiper"
        options={({ route }) => ({ title: route.params.name })}
        component={Swiper}
      />

      <RootStack.Screen
        name="FullImage"
        component={FullImage}
        options={({ route }) => ({ title: route.params.name })}
      />

      <RootStack.Screen
        name="TermsConditions"
        component={TermsAndConditions}
        options={{ headerShown: false }}
      />

      <RootStack.Screen name="PicksView" component={PicksView} />

      <RootStack.Screen
        name="OtherProfile"
        component={Profile}
        options={({ route }) => ({ title: route.params.name })}
      />
    </RootStack.Navigator>
    </SafeAreaProvider>

  );
}
